import React, { useState } from 'react';
import { useAuthStore } from '@/store/authStore';
import { authAPI } from '@/services/api';
import { Mail, CheckCircle2, Send } from 'lucide-react';

/** Personal/login email verification — one-click magic link, no OTP text box. */
export default function EmailVerifyCard({ testIdPrefix = 'email' }) {
  const { user, loadUser } = useAuthStore();
  const [sending, setSending] = useState(false);
  const [msg, setMsg] = useState('');

  const verified = !!user?.is_email_verified;

  const sendLink = async () => {
    setSending(true);
    setMsg('');
    try {
      const r = await authAPI.sendEmailVerification();
      if (r.already_verified) {
        await loadUser();
        setMsg('Already verified');
      } else {
        setMsg('Verification link sent — check your inbox and click it to verify.');
      }
    } catch (err) {
      setMsg('Error: ' + (err.response?.data?.detail || err.message));
    }
    setSending(false);
  };

  return (
    <div className="bg-white dark:bg-[#111114] border border-slate-200 dark:border-zinc-800/50 rounded-lg p-5" data-testid={`${testIdPrefix}-verify-email-card`}>
      <h3 className="text-slate-900 dark:text-white font-medium text-sm flex items-center gap-2 mb-1">
        <Mail className="w-4 h-4" /> Verify Email
      </h3>
      <p className="text-slate-500 dark:text-zinc-500 text-xs mb-4">{user?.email}</p>

      {verified ? (
        <span className="inline-flex items-center gap-1.5 text-xs px-2.5 py-1 rounded-full bg-emerald-500/10 text-emerald-600 dark:text-emerald-400" data-testid={`${testIdPrefix}-email-verified-badge`}>
          <CheckCircle2 className="w-3.5 h-3.5" /> Verified
        </span>
      ) : (
        <>
          <button onClick={sendLink} disabled={sending}
            className="flex items-center gap-1.5 px-4 py-2 bg-emerald-600 hover:bg-emerald-500 text-white rounded-lg text-sm disabled:opacity-50"
            data-testid={`${testIdPrefix}-send-verify-email-btn`}>
            <Send className="w-3.5 h-3.5" /> {sending ? 'Sending…' : 'Verify Email'}
          </button>
          {msg && <p className={`text-xs mt-2 ${msg.startsWith('Error') ? 'text-red-600 dark:text-red-400' : 'text-emerald-600 dark:text-emerald-400'}`} data-testid={`${testIdPrefix}-verify-email-msg`}>{msg}</p>}
        </>
      )}
    </div>
  );
}
